<div class="crime-picker" [class.is-error]="invalid">
    @if (showTitle) {
    <div class="crime-picker__title">{{ titleText }}</div>
    } @if (subtitlePosition === 'above') {
    <div class="crime-picker__subtitle">{{ subtitleText }}</div>
    } @if (variant === 'pills') {
    <div class="crime-picker__pills" role="group" [attr.aria-label]="titleText">
        <!-- type="button": this renders inside the register <form>, where a bare
      button would default to submit and fire the form on every tap. -->
        @for (crimeType of crimeTypes; track crimeType) {
        <button
            type="button"
            class="crime-picker__pill"
            [class.is-selected]="isSelected(crimeType.id)"
            [attr.aria-pressed]="isSelected(crimeType.id)"
            [disabled]="isOptionDisabled(crimeType)"
            (click)="toggle(crimeType.id)"
        >
            {{ crimeType.name }}
        </button>
        }
    </div>
    } @if (variant === 'checkboxes') {
    <div
        class="crime-picker__checks"
        role="group"
        [attr.aria-label]="titleText"
    >
        @for (crimeType of crimeTypes; track crimeType) {
        <ion-checkbox
            class="crime-picker__check ion-text-wrap"
            mode="md"
            labelPlacement="end"
            justify="start"
            [checked]="isSelected(crimeType.id)"
            [disabled]="isOptionDisabled(crimeType)"
            (ionChange)="toggle(crimeType.id)"
        >
            {{ crimeType.name }}
        </ion-checkbox>
        }
    </div>
    } @if (subtitlePosition === 'below') {
    <div class="crime-picker__subtitle crime-picker__subtitle--below">
        {{ subtitleText }}
    </div>
    }
</div>
